<section class="hd-memory-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-memory-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-memory-cheat-sheet-page__controls" aria-label="Memory cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-memory-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-memory-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-memory-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }
  @if (pageSubtitle()) {
    <p class="hd-memory-cheat-sheet-page__subtitle">{{ pageSubtitle() }}</p>
  }

  <div class="hd-memory-cheat-sheet-page__deck">
    <!-- Linkerhelft: zes blokjes + het linker info-blok -->
    <div class="hd-memory-cheat-sheet-page__side">
      <div class="hd-memory-cheat-sheet-page__blocks">
        @for (block of leftBlocks(); track block.gate) {
          <hd-memory-cheat-block [block]="block" />
        }
      </div>

      <div class="mem-info-card">
        <h3 class="mem-info-card__title">{{ circuitTitle() }}</h3>
        <ul class="mem-info-card__bullets">
          @for (bullet of leftBullets(); track $index) {
            <li>{{ bullet }}</li>
          }
        </ul>
      </div>
    </div>

    <!-- Centrale bodygraph met de geheugenpoorten gemarkeerd -->
    <div class="hd-memory-cheat-sheet-page__center">
      <img class="hd-memory-cheat-sheet-page__chart" [src]="circuitImage" [alt]="chartAlt()" />
    </div>

    <!-- Rechterhelft: zes blokjes + het rechter info-blok -->
    <div class="hd-memory-cheat-sheet-page__side">
      <div class="hd-memory-cheat-sheet-page__blocks">
        @for (block of rightBlocks(); track block.gate) {
          <hd-memory-cheat-block [block]="block" />
        }
      </div>

      <div class="mem-info-card">
        <h3 class="mem-info-card__title">{{ circuitTitle() }}</h3>
        <ul class="mem-info-card__bullets">
          @for (bullet of rightBullets(); track $index) {
            <li>{{ bullet }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
</section>
